const availableFilters = [
	{ label: 'Priority', key: 'Priority__c', type: 'list', values: ["Low", "Medium", "High"]},
	{ label: 'Status', key: 'Status__c', type: 'list', values: ["Planned", "Under Review", "In Progress", "Application Ready", "Approved" ]}
];

export default availableFilters;
